require('./shared/layout');

import $ from 'jquery';
import Axios from 'axios';
import { parseQueryParams } from './shared/utils';

var axios = Axios.create({});
$(document).ready(function () {
  var searchParams = parseQueryParams(window.location.search || '');

  var formError;
  var formSuccess;
  var processing;

  var isPasswordResetPage =
    window.location.href.indexOf('/password/reset') > -1;

  if (isPasswordResetPage && !searchParams.code) {
    return (window.location.href = '/signin/index.html');
  }

  var setFormError = function (error) {
    formError = error;
    var el = $('#form_error');
    if (error === null) {
      el.text('');
      el.hide();
    } else {
      el.text(error.message || error);
      el.show();
    }
  };

  var setFormSuccess = function () {
    formSuccess = true;
  };

  var setProcessing = function (state) {
    processing = state;
    var btn = $('#form_recover .cta_wrap .cta_btn');
    if (processing === true) {
      btn.addClass('processing');
    } else {
      btn.removeClass('processing');
    }

    btn.attr('disabled', processing);
    var inputs = $('#form_recover input');
    inputs.attr('disabled', processing);
  };

  var onFormSuccess = function () {
    var headerText = 'Request Sent';
    var descText =
      'We have sent you an email to the provided address which includes insturctions to change your password.';

    if (isPasswordResetPage) {
      headerText = 'Password Changed';
      descText = 'Redirecting you to Sign in ..';
    }

    $('.title_main').text(headerText);
    $('.titles_wrap .desc').text(descText);
    $('.layout_col .hint_wrap').hide();

    $('.section_wrap').addClass('success');

    if (isPasswordResetPage) {
      var redirecUri = searchParams.redirect;
      if (redirecUri) {
        redirecUri = decodeURI(searchParams.redirect);
      } else {
        redirecUri = '/signin/index.html';
      }

      setTimeout(() => {
        window.location.href = redirecUri;
      }, 5000);
    }

    $('#form_recover').hide();
  };

  var onFormFailed = function (err) {
    setFormError(err);
    $('#input_password').val('');
  };

  function checkAutoFill() {
    if (searchParams.email) {
      $('#input_uid').val(searchParams.email);
    }
  }

  function prependSearchParams() {
    $('[data-auth-link]').each((i, a) => {
      var hrefurl = $(a).prop('href');
      if (hrefurl.indexOf('?') > -1) {
        hrefurl += '&';
      } else {
        hrefurl += '?';
      }

      var searchParamKeys = Object.keys(searchParams);
      if (searchParamKeys.length) {
        searchParamKeys.forEach((prop) => {
          hrefurl += prop + '=' + searchParams[prop];
        });
      }

      a.href = hrefurl;
    });
  }

  function onFormSubmit(ev) {
    ev.preventDefault();
    if (processing) return;

    var email = $('#input_uid');
    var pass = $('#input_password');
    var passConfirm = $('#input_password_confirm');

    var emailValue = email.val();
    var passValue = pass.val();
    var passConfirmValue = passConfirm.val();

    var payload = {};

    if (isPasswordResetPage) {
      if (!passValue || !passConfirmValue) {
        return setFormError({
          message: 'Please type new passwords',
        });
      }

      payload = {
        passphrase: passValue,
        confirmPassphrase: passConfirmValue,
        code: searchParams.code,
      };
    } else {
      if (!emailValue) {
        return setFormError({
          message: 'Please type in your email',
        });
      }

      payload = {
        email: emailValue,
        recoveryPageURI: process.env['RECOVERY_REDIRECT_URL'],
      };
    }

    setFormError(null);
    setProcessing(true);

    setTimeout(() => {
      submitRecover(payload).then(
        function (res) {
          console.log('res', res && res.data);
          setFormSuccess(true);
          onFormSuccess();

          setProcessing(false);
        },
        function (e) {
          console.log('error', e);
          var err = e && e.response && e.response.data;
          onFormFailed(err);

          setProcessing(false);
        },
      );
    }, 1000);
  }

  function submitRecover(payload) {
    return new Promise(function (res, rej) {
      payload = Object.assign(payload);

      var apiPathname = '/recover/password';
      if (isPasswordResetPage) {
        apiPathname = '/recover/password/__apply';
      }

      var apiUri = process.env.AUTH_API_BASE + apiPathname;
      console.log('apiUri', apiUri, payload);
      axios.post(apiUri, payload).then(res, rej);
    });
  }

  $('#form_recover').submit(onFormSubmit);

  checkAutoFill();
  prependSearchParams();
});
